import { render } from "./AposTiptapInsertBtn.vue?vue&type=template&id=3145f924"
import script from "./AposTiptapInsertBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./AposTiptapInsertBtn.vue?vue&type=script&setup=true&lang=js"

import "./AposTiptapInsertBtn.vue?vue&type=style&index=0&id=3145f924&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"rich-text-widget/ui/apos/components/AposTiptapInsertBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3145f924"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3145f924', __exports__)) {
    api.reload('3145f924', __exports__)
  }
  
  module.hot.accept("./AposTiptapInsertBtn.vue?vue&type=template&id=3145f924", () => {
    api.rerender('3145f924', render)
  })

}


export default __exports__